import { IonContent, IonInput, IonPage, IonText, IonIcon } from "@ionic/react";
import { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router";
import DataTable from "react-data-table-component";
import service from "../Service/service";
import Head from "./Header";
import Sidebar from "./Sidebar";

const MissingTimesheet: React.FC = () => {
    const history = useHistory();
    const [Id] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (Id === null) {
            history.push("/login");
        } else {
        }
    }, [Id, history]);
    const [data, setData]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");

    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [employeelist, setEmployeelist] = useState([]);

    const [modalopen, setModalopen] = useState(false);
    const [modalopen1, setModalopen1] = useState(false);
    const [timeSheets, settimesheets] = useState([])
    const closemodal = () => {
        setModalopen(false);
    }
    const View = (timeSheetsData: any) => {
        settimesheets(timeSheetsData);
        setModalopen(true);

    }
    useEffect(() => {
        MissingTimesheet();

    }, []);

    const MissingTimesheet = () => {
        service.MissingTime(Id)
            .then((response) => {
                console.log(response, "data")
                if (response.status === 200) {
                    setData(response.data);
                }
                else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.log(error)
            })
    }


    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: false,
            // width: "100px", // Set a fixed width for this column
        },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit.businessUnitName,
            sortable: true,
            // width: "200px", // Set a fixed width for this column
        },
        {
            name: "Department Unit",
            selector: (itm: any) => itm.masterDepartment.departmentName,
            sortable: true,
            // width: "250px", // Set a fixed width for this column
        },
        {
            name: "Employee Name",
            selector: (itm: any) => itm.name,
            sortable: true,
            sort: "name",
            width: "350px", // Set a fixed width for this column
            cell: (itm: any) => (
                <>
                    <div className="wrapper_cls">{itm.employeeName}{" ("}{itm.employeeId}{")"}</div>
                </>
            )
        },
        {
            name: "Week",
            selector: (itm: any) => itm.week,
            // width: "250px", // Set a fixed width for this column
            sortable: true,
        },
        {
            name: "Action",
            sortable: false,
            // width: "150px", // Set a fixed width for this column
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", textUnderlinePosition: "under" }}>
                        <IonText onClick={() => View(itm.timeSheets)} style={{ color: "coral", cursor: 'pointer' }}>View</IonText>
                    </div>
                </>
            )
        }
    ]

    const back = () => {
        history.goBack();
    }
    const datatable = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);




    return (
        <IonPage>
            <Head />
            <Sidebar />
            <Modal dialogClassName="modal-dialog modal-lg" show={modalopen}>
                <div className="modal-header">
                    <h5 className="modal-title"> Missing Timesheet </h5>
                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div className="modal-body">
                    <form>
                        <div className="form-group" style={{ marginTop: "2%" }}>
                            {/* <label style={{ fontWeight: "bold" }}>Pending Timesheet</label> */}
                            <div className="form-control datetimepicker" style={{ height: "150px", overflowY: "scroll", backgroundColor: "#DCDCDC" }}>
                                {timeSheets && timeSheets.length > 0 && timeSheets.map((itm: any) => (
                                    <li key={itm.id}>{itm}</li>
                                ))}
                            </div>
                        </div>
                    </form>

                </div>

            </Modal>
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="col">
                                <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                    <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                    Missing Timesheet</h3>
                            </div>
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </IonContent>
        </IonPage>
    )
}

export default MissingTimesheet;